// Static compile-time feature flags. No runtime server lookup — the flags
// are part of the bundle, so changing one requires a deploy.
//
// The current codebase does not have a feature-flag service (GrowthBook /
// LaunchDarkly / a config endpoint), so this file intentionally starts
// minimal. If a flag service is introduced later, the shape here should
// be replaced with a hook that reads from that service; call sites already
// import FEATURE_FLAGS as an object, so the migration is contained.

export const FEATURE_FLAGS = {
  // AGENT.A3 — When true, per-phase configuration is collected as the
  // opening turns of the agent chat (see the AGENT.A1/A2/A3 rollout).
  // The standalone "Configure Phase" modal is hidden in this mode.
  //
  // Set to false to restore the pre-rollout modal flow — useful as a
  // rollback if the in-chat dialogue surfaces a regression. The modal
  // component is intentionally NOT deleted so this flip is side-effect-free.
  PHASE_CONFIG_IN_CHAT: true,

  // PKGV.A2 (#793) — <PKGNeighbourhoodPanel /> embedded in the Decisions
  // and Risks list pages' inline-expand rows. Static and ON by default
  // (the tenant-runtime "default ON tenant-level" AC in the original
  // issue was struck at adjudication — no tenant-scoped flag store
  // exists in this codebase; see Sprint-A2-recon.md L9).
  //
  // Set to false to hide the panel everywhere with zero risk to the
  // host pages — the embed is purely additive, so flipping this off
  // restores DecisionsPage/RisksPage to their pre-A2 behaviour exactly.
  PKG_NEIGHBOURHOOD_PANEL_ENABLED: true,

  // PKGV.B2 (#796) — gates the /projects/:projectId/pkg-explorer route
  // and its dashboard-overview entry card. Default ON; flip to false to
  // roll back without deleting the page (Definition of Done's rollback
  // path — zero data risk, user_pkg_bookmarks is additive and untouched
  // by this flag).
  PKG_EXPLORER_ENABLED: true,

  // PKGV.D4 (#804) — "Knowledge Graph Health" section (<ExecPKGSummary />)
  // on the TENANT_ADMIN settings page. Static and ON by default, same
  // reasoning as PKG_NEIGHBOURHOOD_PANEL_ENABLED above: there is no
  // tenant-scoped flag store in this codebase, so "default ON for
  // TENANT_ADMIN role" is two independent gates (this flag + the
  // isAdmin check at the call site), not one role-aware flag.
  //
  // Set to false to hide the settings-page card (and its route) with
  // zero risk — purely additive, so flipping this off restores
  // SettingsPage.tsx to its pre-D4 behaviour exactly.
  EXEC_PKG_SUMMARY_ENABLED: true,
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

/**
 * Small helper so call sites read as `isFeatureEnabled('PHASE_CONFIG_IN_CHAT')`
 * instead of `FEATURE_FLAGS.PHASE_CONFIG_IN_CHAT`. Either form works — the
 * helper just makes the intent obvious in JSX guards.
 */
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return FEATURE_FLAGS[flag];
}
